import { render, staticRenderFns } from "./AddRelatedDocument.vue?vue&type=template&id=28032786&"
import script from "./AddRelatedDocument.vue?vue&type=script&lang=js&"
export * from "./AddRelatedDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28032786')) {
      api.createRecord('28032786', component.options)
    } else {
      api.reload('28032786', component.options)
    }
    module.hot.accept("./AddRelatedDocument.vue?vue&type=template&id=28032786&", function () {
      api.rerender('28032786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/wizard/flow/components/AddRelatedDocument.vue"
export default component.exports